/* eslint-disable no-restricted-syntax */
import Suggestion from 'components/Suggestion.vue';
import SelectPersons from 'components/SelectPersons.vue';
import FlatPickrBase from 'components/FlatPickrBase.vue';
import FilterPriceRange from 'components/FilterPriceRange.vue';
import FilterBool from 'components/FilterBool.vue';
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import { BFormCheckbox, BFormRadio, BFormCheckboxGroup } from 'bootstrap-vue';
import intersection from 'lodash.intersection';
import getNumberFormat from 'mixins/composition/NumberFormat';

import { searchBoolFilterNames } from 'router/guards/queryConfig';
// get propertys named in GTM dataLayer
import { gtmFilterMapping } from 'config/trackingParams';

import config from 'config/appConfig';

export const computed = {
  data() {
    return {
      agencies: config.agencies,
    };
  },
  setup(_, ctx) {
    const { formatNumber } = getNumberFormat(ctx);
    return { formatNumber };
  },
  computed: {
    experimentHideTolerance() {
      const experiment = this.$store.getters.getExperimentById('experiment_EDVUE-3563');
      // console.log(experiment);
      const variantClasses = {
        original: 'original',
        variant1: 'default-on',
      };
      // return css classname
      return variantClasses[experiment.variant] || '';
      // return '';
    },
    deactivateTolerance() {
      // console.log('experimentHideTolerance', this.experimentHideTolerance);
      return this.experimentHideTolerance === 'force-hide';
    },
    showCancelations() {
      return config.search.showCancelations;
    },
    agencySelect: {
      get() {
        const agencies = this.$store.getters.getSearchFilter('agency');
        if (agencies) return agencies.toString().split(',');
        return [];
      },
      set(newAgencies) {
        const agencyString = newAgencies.join(',');
        const gtmString = `${gtmFilterMapping.agency}_${agencyString || ''}`;
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        searchRedirect({ router: this.$router, filters: { agency: agencyString } });
      },
    },
    partnerTagsSelect: {
      get() {
        const partnerTags = this.$store.getters.getSearchFilter('partnerTags');
        if (partnerTags) return partnerTags.toString().split(',');
        return [];
      },
      set(newPartnerTags) {
        const partnerTagsString = newPartnerTags.join(',');
        searchRedirect({ router: this.$router, filters: { partnerTags: partnerTagsString } });
      },
    },
    partnerTags() {
      return this.$store.getters.getAggregation('partnerTags');
    },
    partnerTagName() {
      return this.$store.getters.getPartnerConfigValue('partnerTagName');
    },
    objectTypes() {
      const options = [
        {
          value: '',
          text: `${(this.breakpointPrefix === 'short' ? this.$t('filter:options.short.objecttype') : this.$t('filter:select.any'))}`,

        },
        {
          value: 'house',
          text: `${this.$i18n.i18next.t('filter:select.house')} ${this.filterTypeCounter('objectTypes', 'house') > 0 ? `(${this.formatNumber(this.filterTypeCounter('objectTypes', 'house'))})` : ''}`,
          disabled: (this.filterTypeCounter('objectTypes', 'house') > 0 ? '' : 'disabled'),
        },
        {
          value: 'apartment',
          text: `${this.$i18n.i18next.t('filter:select.apartment')} ${this.filterTypeCounter('objectTypes', 'apartment') > 0 ? `(${this.formatNumber(this.filterTypeCounter('objectTypes', 'apartment'))})` : ''}`,
          disabled: (this.filterTypeCounter('objectTypes', 'apartment') > 0 ? '' : 'disabled'),
        },

      ];
      return options;
    },
    ratingOptions() {
      const ratings = ['1', '2', '3', '4'];
      let disableString = '';
      const options = [{
        value: 0,
        text: `${this.$t('filter:select.any', { postProcess: 'interval', count: 0 })}`,
        disabled: disableString,
      }];
      ratings.forEach((rate) => {
        let counterString = this.filterTypeCounter('ratingAverage', rate);
        if (counterString > 0) {
          counterString = `(${this.formatNumber(counterString)})`;
          disableString = '';
        } else {
          counterString = '';
          disableString = ((counterString > 0 ? '' : 'disabled'));
        }
        const obj = {
          value: rate,
          text: `${this.$t('filter:select.tabs.rating_text', { postProcess: 'interval', count: parseInt(rate, 5) })} ${counterString}`,
          disabled: disableString,

        };
        options.push(obj);
      });
      return options;
    },
    sleepingRoomOptions() {
      const sleepingRooms = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      // const totalCountStr = `(${this.totalCount})`;
      let disableString = '';
      // first empty option with total Count
      const options = [{
        value: '',
        text: `${this.$t(`filter:options.${this.breakpointPrefix}.sleeping_interval`, { postProcess: 'interval', count: 0 })}`,
        disabled: disableString,
      }];
      sleepingRooms.forEach((room) => {
        let counterString = this.filterTypeCounter('sleeping', room);
        if (counterString > 0) {
          counterString = `(${this.formatNumber(counterString)})`;
          disableString = '';
        } else {
          counterString = '';
          disableString = ((counterString > 0 ? '' : 'disabled'));
        }
        const obj = {
          value: room,
          text: `${this.$t(`filter:options.${this.breakpointPrefix}.sleeping_interval`, { postProcess: 'interval', count: parseInt(room, 10) })} ${counterString}`,
          disabled: disableString,
        };
        options.push(obj);
      });

      return options;
    },

    bathVariantOptions() {
      const bathRooms = [2, 3];
      let disableString = '';
      const options = [{
        value: '',
        text: `${this.$t(`filter:options.${this.breakpointPrefix}.bath_interval`, { postProcess: 'interval', count: 0 })}`,
        disabled: disableString,
      }];
      bathRooms.forEach((room) => {
        let counterString = this.filterTypeCounter('bath', room);
        if (counterString > 0) {
          counterString = `(${this.formatNumber(counterString)})`;
          disableString = '';
        } else {
          counterString = '';
          disableString = ((counterString > 0 ? '' : 'disabled'));
        }
        const obj = {
          value: room,
          text: `${this.$t(`filter:options.${this.breakpointPrefix}.bath_interval`, { postProcess: 'interval', count: parseInt(room, 10) })} ${counterString}`,
          disabled: disableString,
        };
        options.push(obj);
      });

      return options;
    },
    petVariantOptions() {
      const pets = [
        { value: 'one', count: 1, text: 'Haustier erlaubt' },
        { value: 'more', count: 2, text: 'mehrere Haustiere erlaubt' },
        { value: 'none', count: 3, text: 'Haustiere nicht erlaubt' },
      ];
      let disableString = '';
      const options = [{
        value: '',
        text: `${this.$t(`filter:options.${this.breakpointPrefix}.pet_interval`, { postProcess: 'interval', count: 0 })}`,
        disabled: disableString,
      }];
      pets.forEach((pet) => {
        let counterString = this.filterTypeCounter('pets', pet.value);
        if (counterString > 0) {
          counterString = `(${this.formatNumber(counterString)})`;
          disableString = '';
        } else {
          counterString = '';
          disableString = ((counterString > 0 ? '' : 'disabled'));
        }
        const obj = {
          value: pet.value,
          text: `${this.$t(`filter:options.${this.breakpointPrefix}.pet_interval`, { postProcess: 'interval', count: parseInt(pet.count, 10) })} ${counterString}`,
          disabled: disableString,
        };
        options.push(obj);
      });

      return options;
    },
    squaremeterLivingOptions() {
      const squaremeters = [35, 60, 85, 110, 135, 160, 185];
      let disableString = '';
      const options = [{
        value: 0,
        text: `${this.$t(`filter:options.${this.breakpointPrefix}.squaremeterLiv_interval`, { postProcess: 'interval', count: 0 })}`,
        disabled: disableString,
      }];
      squaremeters.forEach((sm) => {
        let counterString = this.filterTypeCounter('squaremeterLiving', sm);
        if (counterString > 0) {
          counterString = `(${this.formatNumber(counterString)})`;
          disableString = '';
        } else {
          counterString = '';
          disableString = ((counterString > 0 ? '' : 'disabled'));
        }
        const obj = {
          value: sm,
          text: `${this.$t(`filter:options.${this.breakpointPrefix}.squaremeterLiv_interval`, { postProcess: 'interval', count: parseInt(sm, 10) })} ${counterString}`,
          disabled: disableString,
        };
        options.push(obj);
      });

      return options;
    },
    totalCount() {
      const resultCount = this.$store.state.searchTotalObjects;
      // this.setPagination();
      return this.formatNumber(resultCount);
    },

    filterTypeCount() {
      return (filterName, value) => {
        if (!filterName) {
          return '';
        }
        const countResult = this.$store.getters.getAggregationTypeCount(filterName, value);
        return (countResult && parseInt(countResult, 10) >= 0) ? ` (${countResult})` : '';
      };
    },

    filterTypeCounter() {
      return (name, value) => this.$store.getters.getAggregationTypeCount(name, value);
    },
    filterCounter() {
      return (name) => this.$store.getters.getSearchFilterCount(name);
    },
    group: {
      get() {
        return ((this.$store.getters.getSearchFilter('group')) ? 'Y' : 'N');
      },
      set() {
        searchRedirect({ router: this.$router, filters: { group: '' } });
      },
    },
    countrySelect: {
      get() {
        return this.$store.getters.getSearchLocationFilter('country');
      },
      set(newCountry) {
        this.setSearchLocation({ country: newCountry });
        // searchRedirect();
      },
    },
    sleepingRooms: {
      get() {
        return this.$store.getters.getSearchFilter('sleepingRooms') || '';
      },
      set(newSleepingRooms) {
        if (this.checkQuery({ sleepingRooms: newSleepingRooms })) {
          const gtmString = `${gtmFilterMapping.sleepingRooms}_${newSleepingRooms || 'beliebig'}`;
          this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
          searchRedirect({ router: this.$router, filters: { sleepingRooms: newSleepingRooms } });
        }
      },
    },
    bathRooms: {
      get() {
        return this.$store.getters.getSearchFilter('bathRooms') || '';
      },
      set(newBathRooms) {
        if (this.checkQuery({ bathRooms: newBathRooms })) {
          const gtmString = `${gtmFilterMapping.bathRooms}_${newBathRooms || 'beliebig'}`;
          this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
          searchRedirect({ router: this.$router, filters: { bathRooms: newBathRooms } });
        }
      },
    },
    objectType: {
      // added if statement to show another object first in mobile view
      get() {
        const objectType = this.$store.getters.getSearchFilter('objectType') || '';
        return objectType;
      },
      set(newObjectType) {
        if (this.checkQuery({ objectType: newObjectType })) {
          searchRedirect({ router: this.$router, filters: { objectType: newObjectType } });
          const gtmString = gtmFilterMapping.objectType[newObjectType || 'alltypes'];
          this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        }
      },
    },
    rating: {
      get() {
        return this.$store.getters.getSearchFilter('rating') || 0;
      },
      set(newRating) {
        searchRedirect({ router: this.$router, filters: { rating: newRating } });
      },
    },
    persons: {
      get() {
        return (this.$store.getters.getSearchFilter('persons') || '2').toString();
      },
      set(newPersons) {
        const gtmString = `${gtmFilterMapping.persons}_${newPersons || '2'}`;
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        searchRedirect({ router: this.$router, filters: { persons: newPersons.toString() } });
      },
    },
    pets: {
      get() {
        return this.$store.getters.getSearchFilter('pets') || '';
      },
      set(newPets) {
        const gtmString = gtmFilterMapping.pets[newPets] || 'haustier_beliebig';
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        searchRedirect({ router: this.$router, filters: { pets: newPets.toString() } });
      },
    },
    freeCancel: {
      get() {
        return this.$store.getters.getSearchFilter('freeCancel') || '';
      },
      set(newFreeCancel) {
        let usedNewFreeCancel = '';
        // bootstrap component returns false then null when unselecting for no apparent reason => intercept!
        if (newFreeCancel !== false && newFreeCancel !== null) usedNewFreeCancel = newFreeCancel;

        const gtmString = gtmFilterMapping.freeCancel[usedNewFreeCancel] || 'stornierung_beliebig';
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });

        searchRedirect({ router: this.$router, filters: { freeCancel: usedNewFreeCancel } });
      },
    },
    squaremeterLiving: {
      get() {
        const smLiving = this.$store.getters.getSearchFilter('squaremeterLiving') || 0;
        return smLiving;
      },
      set(newSquaremeterLiving) {
        const newQObject = { squaremeterLiving: newSquaremeterLiving };
        if (this.checkQuery(newQObject)) {
          this.dataLayerPush({ event: 'asnnutzung', asnfilter: `squaremeterLiving_${newSquaremeterLiving}` });
          searchRedirect({ router: this.$router, filters: newQObject });
        }
      },
    },
    activeAccomodation() {
      let activeCounter = 0;
      if (this.objectTypeDefault !== this.objectType) { activeCounter += 1; }
      if (this.sleepingRoomsDefault !== this.sleepingRooms) { activeCounter += 1; }
      if (this.bathRoomsDefault !== this.bathRooms) { activeCounter += 1; }
      if (this.squaremeterLivingDefault !== this.squaremeterLiving) { activeCounter += 1; }
      return activeCounter;
    },
    activeDistances() {
      let activeCounter = 0;
      const distSea = this.$store.getters.getSearchFilter('distSea') || 0;
      const distLake = this.$store.getters.getSearchFilter('distLake') || 0;
      const distSkilift = this.$store.getters.getSearchFilter('distSkilift') || 0;
      const distSkiloipe = this.$store.getters.getSearchFilter('distSkiloipe') || 0;
      if (distSea > 0) { activeCounter += 1; }
      if (distLake > 0) { activeCounter += 1; }
      if (distSkilift > 0) { activeCounter += 1; }
      if (distSkiloipe > 0) { activeCounter += 1; }
      return activeCounter;
    },
    activeAmenities() {
      const activeFilters = this.$store.getters.getSearchFilters;
      const boolAmenities = intersection(searchBoolFilterNames, Object.keys(activeFilters));
      const returnFilters = {};
      boolAmenities.forEach((key) => {
        if (activeFilters[key] !== 0) {
          returnFilters[key] = activeFilters[key];
        }
      });
      return returnFilters;
    },
    activeAmenitiesCount() {
      let intersect = 0;
      intersect = intersection(searchBoolFilterNames, Object.keys(this.activeAmenities)).length;
      return intersect;
    },
    activeAgenciesCount() {
      let activeCounter = 0;
      const providerType = this.$store.getters.getSearchFilter('providerType') || '';
      const agencies = this.$store.getters.getSearchFilter('agency') || '';
      const insObject = this.$store.getters.getSearchFilter('insObject') || '';
      if (providerType !== '') { activeCounter += 1; }
      if (agencies !== '') { activeCounter += agencies.toString().split(',').length; }
      if (insObject !== '') { activeCounter += 1; }
      return activeCounter;
    },
    activeLabelCount() {
      let activeCounter = 0;
      if (this.partnerTagsSelect.length > 0) { activeCounter += this.partnerTagsSelect.length; }
      return activeCounter;
    },
    filterGroups() {
      return {
        pets: ['pets'],
        rating: ['rating'],
        price: ['priceMin', 'priceMax'],
        distances: ['distSea', 'distLake', 'distSkilift', 'distSkiloipe'],
        amenities: Object.keys(this.activeAmenities),
        accomodation: ['sleepingRooms', 'squaremeterLiving', 'bathRooms', 'objectType'],
        agencies: ['providerType', 'agency', 'insObject'],
        tolerance: ['tolerance'],
        freeCancel: ['freeCancel'],
        label: ['partnerTags'],
      };
    },
    offer() {
      return this.$store.getters.getSearchFilter('offer');
    },
    startDate() {
      return this.$store.getters.getSearchFilter('startDate');
    },
    offerName() {
      return this.$store.getters.getOfferContent(this.offerID).nameIncluded || this.$store.getters.getOfferContent(this.offerID).name;
    },
    offerID() {
      return this.$route.params.offer || this.$route.query.offer || this.$route.meta?.searchFilter?.offer;
    },
    lastminute() {
      return this.$store.getters.getSearchFilter('lastminuteonly');
    },
    providerTypes() {
      return [
        { value: '', text: 'all' },
        { value: 'retailer', text: 'onlyEDom' },
        { value: 'wholesaler', text: 'onlyOthers' },
      ];
    },
    providerType: {
      get() {
        return (this.$store.getters.getSearchFilter('providerType') || '').toString();
      },
      set(newProviderType) {
        searchRedirect({ router: this.$router, filters: { providerType: newProviderType.toString() } });
      },
    },
    insObjectTypes() {
      return [
        { value: '', text: 'all' },
        { value: 'Y', text: 'filter' },
        { value: 'N', text: 'ignore' },
      ];
    },
    insObject: {
      get() {
        return (this.$store.getters.getSearchFilter('insObject') || '').toString();
      },
      set(newInsObject) {
        searchRedirect({ router: this.$router, filters: { insObject: newInsObject.toString() } });
      },
    },
    tolerance: {
      get() {
        const tolerance = this.$store.getters.getSearchFilter('tolerance') || '';
        if (tolerance !== '') return parseInt(tolerance, 10);
        return '';
      },
      set(newTolerance) {
        const gtmString = `${gtmFilterMapping.tolerance[newTolerance]}`;
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
        searchRedirect({ router: this.$router, filters: { tolerance: newTolerance.toString() } });
      },
    },
    toleranceVariantOptions() {
      return [
        { value: '', text: this.$t('filter:toleranceOptions.exact') },
        { value: 1, text: this.$t('filter:toleranceOptions.withVariation', { numOfDays: 1 }) },
        { value: 2, text: this.$t('filter:toleranceOptions.withVariation', { numOfDays: 2, count: 2 }) },
        { value: 3, text: this.$t('filter:toleranceOptions.withVariation', { numOfDays: 3, count: 3 }) },
      ];
    },
    searchIsReady() {
      return this.$store.state.searchSuccessfull && this.$store.state.locationSuccessfull;
    },
    showMissingDate() {
      let show = false;
      const startDate = this.$store.getters.getSearchFilter('startDate');
      const endDate = this.$store.getters.getSearchFilter('endDate');
      if (!startDate && !endDate && !this.$store.state.isSeoPage) {
        show = true;
      }
      return show;
    },
    openDatePicker() {
      let missingDate = this.showMissingDate;
      if (this.$store.state.flatpickrOpened === true) {
        missingDate = false;
      }
      return missingDate;
    }
  },
  methods: {
    removeGroup() {
      this.setSearchFilter({ group: '' });
      this.$router.push({
        name: 'Search',
        hash: '#searchResult',
        query: Object.assign(this.$store.getters.getMergedTerms, this.headerSearchQuery),
      });
    },
    removeLastminute() {
      this.setSearchFilter({ lastminuteonly: '' });
      this.$router.push({
        name: 'Search',
        hash: '#searchResult',
        query: Object.assign(this.$store.getters.getMergedTerms, this.headerSearchQuery),
      });
    },
    removeOffer() {
      this.setSearchFilter({
        offer: '', onr: '', offerFilter: '', agency: '',
      });
      this.$router.push({
        name: 'Search',
        hash: '#searchResult',
        query: Object.assign(this.$store.getters.getMergedTerms, this.headerSearchQuery),
      });
    },
    checkQuery(newQueryData) {
      const routeQueries = Object.keys(this.$route.query);
      const newEntrie = Object.entries(newQueryData);
      const key = newEntrie[0];
      const val = newEntrie[1];
      if (!routeQueries[key]) { return true; }
      if (routeQueries[key] !== val) { return true; }
      return false;
    },
    useFreeCancel() {
      if (this.freeCancel === 'Y') {
        this.freeCancel = '';
      } else {
        this.freeCancel = 'Y';
      }
    },
  },
};
export const data = {
  data() {
    return {
      searchFilter: searchBoolFilterNames,
      filterHaustiere: false,
      filterSchlafzimmer: false,
      filterPreis: false,
      filterBadezimmer: false,
      filterKundenbewertung: false,
      filterSquaremeterLiving: false,
      filterEntfernungen: false,
      filterUnterkunft: false,
      filterMore: false,
      filterAusstattung: false,
      distanceTypes: {
        '': 'alle', 1: 'Fußnähe', 5: 'bis 5km', 10: 'bis 10km',
      },
      petVariants: [
        { value: '', text: 'beliebig' },
        { value: 'one', text: 'ein Haustier erlaubt' },
        { value: 'more', text: 'mehrere Haustiere erlaubt' },
        { value: 'none', text: 'Haustiere nicht erlaubt' },
      ],
      squaremeterLivingVariants: [10, 35, 60, 85, 110, 135, 160, 185],
      maxSleepingRooms: 11,
      activeSelects: [],
      objectTypeDefault: '',
      bathRoomsDefault: '',
      sleepingRoomsDefault: '',
      squaremeterLivingDefault: 0,
    };
  },
};
export const methods = {
  methods: {
    filterCount(filterName) {
      if (!filterName) {
        return '';
      }
      const countResult = this.filterCounter(filterName);
      // eslint-disable-next-line max-len
      return (countResult > 0) ? ` (${this.formatNumber(countResult)})` : '';
    },
    setPrefix() {
      const longLabel = ['xxl', 'xl', 'lg'];
      if (longLabel.indexOf(this.dh_breakpoint) !== -1) { this.breakpointPrefix = 'long'; } else { this.breakpointPrefix = 'short'; }
    },
    dataLayerPush(object = {}) {
      // push given object to gtm dataLayer
      if (typeof window !== 'undefined') {
        // eslint-disable-next-line no-multi-assign
        const dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push(object);
      }
    },
    setAgencies() {
      const agencies = this.$store.getters.getSearchFilter('agency');
      if (agencies) {
        agencies.toString().split(',').forEach((agencyID) => {
          this.agencySelect[`agency_${agencyID}`] = true;
        });
      } else {
        Object.keys(this.agencySelect).forEach((key) => {
          this.agencySelect[key] = false;
        });
      }
    },
    selectAgency() {
      let agencyString = '';
      const selectedAgencies = [];
      Object.entries(this.agencySelect).forEach((value) => {
        if (value[1] === true) {
          selectedAgencies.push(value[0].split('agency_').join(''));
        }
      });
      agencyString = selectedAgencies.join(',');
      const gtmString = `${gtmFilterMapping.agency}_${agencyString || ''}`;
      this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
      searchRedirect({ router: this.$router, filters: { agency: agencyString } });
    },
  },
};
export const components = {
  components: {
    FilterBool, FilterPriceRange, Suggestion, SelectPersons, FlatPickrBase, BFormCheckbox, BFormRadio, BFormCheckboxGroup,
  },
};
export const watch = {
  watch: {
    rating(newRating) {
      const gtmString = `${gtmFilterMapping.rating}_${newRating || '_beliebig'}`;
      this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });
    },
    breakpoint() {
      this.setPrefix();
    },
  },
};
